
import makerjs from "makerjs";
function B13(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,S1 = Param[2].param, T = Param[3].param,  
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       s1 = S1 * 1 * myZoom,
       t = T * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = s1, x1 = 0, x2 =t ,x3 =s1+b , y0 = 0, y1 = l,y2 = l, y3 =0,glassH =l, glassW = s1+b,h=l,w=s1+b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  } if (s1 !== 0) {
    var TxtS1 = "S1="+S1;
  } if (t !== 0) {
    var TxtT = "T="+T;
  }



   var drawAbnormalShapeB13 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine":new makerjs.paths.Line([x1,y1], [x2,y2]), 
        "RightLine":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "BottomLine": new makerjs.paths.Line([x3,y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeB13MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x1- markShift, y0], [x1- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x1, y1], [x1- 2 * markShift, y1]),
        "RightShortDnline": new makerjs.paths.Line([x1, y0], [x1- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB13MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x3, y3- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB13MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x1, y1+ markShift], [x2, y2+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x1, y1], [x1, y1 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB13MarkS1 = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x1, y0- markShift], [x0, y0- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0- 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x1, y0], [x1, y0- 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB13MarkB, TxtB, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB13MarkT, TxtT, [x1, y1 + 2 * markShift], [x2, y2 + 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB13MarkL, TxtL, [x1-2*markShift, y0], [x1-2*markShift, y1]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB13MarkS1, TxtS1, [x1, y0-2*markShift], [x0, y0-2*markShift]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeB13: drawAbnormalShapeB13,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB13: drawAbnormalShapeB13,
        drawAbnormalShapeB13MarkL: drawAbnormalShapeB13MarkL,
        drawAbnormalShapeB13MarkT: drawAbnormalShapeB13MarkT,
        drawAbnormalShapeB13MarkS1: drawAbnormalShapeB13MarkS1,
        drawAbnormalShapeB13MarkB:drawAbnormalShapeB13MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B13;